import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import './Routes.css';
import CloseIcon from '@material-ui/icons/Close';

class SelectedRoute extends React.PureComponent {
  render() {
    const {
      selectedStopId,
      route,
      stopsToOptimize,
      onStopClick,
      onStopRemove
    } = this.props;
    const stopsToOptimizeInfo = Object.entries(stopsToOptimize);
    const stopToOptimizeIds = Object.keys(stopsToOptimize);
    const routesToOptimize = Object.values(stopsToOptimize)
      .reduce((acc, item) => {
        acc.add(item.prevRoute);
        item.nextRoute && acc.add(item.nextRoute);
        return acc;
      }, new Set());
    return (
      <>
        <div className={`fullwidth flex flex-row space-between route-info selectedRouteHeader ${routesToOptimize.has(route.id) ? "modified" : ""}`}>
          <span>{`${Math.round(route.distance / 1609.34)} mi`}</span>
          <span>{`${Math.round(route.duration / 60)} min`}</span>
          <span className="total-stops">{`${route.stops.length} stops`}</span>
        </div>
        {!!stopsToOptimizeInfo.length && (
          <>
            <p className="title">Recently modified</p>
            <List
              className="selectedRoute"
              style={{ minHeight: '30%', maxHeight: '100%', overflow: 'auto' }}
            >
              {stopsToOptimizeInfo.map(([stopId, stopInfo]) => (
                <ListItem
                  key={stopId}
                  divider={true}
                  className="flex-column baseline"
                >
                  <div className="flex flex-row space-around fullwidth stop-modified">
                    <span className="stop-num" />
                    <ListItemText secondary={`${stopInfo.address}`} />
                    <CloseIcon className="pointer" fontSize="small" color="primary" onClick={() => onStopRemove(stopId)} />
                  </div>
                  <ListItemText className="modified-routes" secondary={`${stopInfo.prevRoute} -> ${stopInfo.nextRoute ? stopInfo.nextRoute : '???'}`} />
                </ListItem>
              ))}
            </List>
          </>
        )}
        <p className="title">Stops</p>
        <List
          className="selectedRoute"
          style={{ maxHeight: '100%', overflow: 'auto' }}
        >
          {route.stops
            .filter(item => !stopToOptimizeIds.includes(item.id))
            .map((item, index) => (
            <ListItem
              key={item.id}
              onClick={() => onStopClick(item.id)}
              divider={true}
              className={`route-stop ${selectedStopId == item.id ? "active-stop" : ""}`}
            >
              <span className="stop-num">
                {(index + 1).toString().padStart(2, '0')}
              </span>
              <ListItemText secondary={`${item.address}`} />
            </ListItem>
          ))}
        </List>
      </>
    );
  }
}

export default SelectedRoute;
